import { useTranslation } from "react-i18next";
import { Alert, Button } from "~/common/mui";
import { getPageDataErrorMessage } from "~/app/api/pageData";
import { ACCOUNT_SELECTION_URL } from "~/utils/url/staticUrls";
import { saveAccountSelectionReturnUrl } from "~/utils/accountSelectionContinuation";

interface Props {
  error: unknown;
  onRetry: () => void;
  priceReferenceContextInvalid: boolean;
  transportError: boolean;
}

export const SessionRecoveryAlert = ({ error, onRetry, priceReferenceContextInvalid, transportError }: Props) => {
  const { t } = useTranslation();
  if (!priceReferenceContextInvalid && !transportError) {
    return null;
  }

  const messageKey = priceReferenceContextInvalid
    ? "session.error.PRICE_REFERENCE_CONTEXT_INVALID"
    : "session.error.TRANSPORT";
  const message = t(messageKey, {
    defaultValue:
      getPageDataErrorMessage(error) ??
      (priceReferenceContextInvalid
        ? "Price reference context is unavailable."
        : "Session data is unavailable. Please retry."),
  });

  return (
    <Alert severity="error" data-testid="price-reference-context-error">
      {message}{" "}
      {priceReferenceContextInvalid ? (
        <Button href={ACCOUNT_SELECTION_URL} onClick={saveAccountSelectionReturnUrl}>
          {t("accountSelectionPage.noAccounts.button", { defaultValue: "Select account" })}
        </Button>
      ) : (
        <Button onClick={onRetry}>{t("session.error.retry", { defaultValue: "Retry" })}</Button>
      )}
    </Alert>
  );
};
